import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EmailService } from '../../services/email.service';
import { AuthService } from '../../services/auth.service';
import { map } from 'rxjs';

@Component({
  selector: 'app-forget-pass-word',
  templateUrl: './forget-pass-word.component.html',
  styleUrls: ['./forget-pass-word.component.css'],
})
export class ForgetPassWordComponent implements OnInit {
  titleCard: string = 'Mot de passe oublié !';
  fromForget!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private emailService: EmailService,
    private authservice:AuthService
  ) {}

  ngOnInit(){

    this.fromForget = this.formBuilder.group({
      email: ['', Validators.required],
    });


  }

  onSubmti() {

    if(this.fromForget.invalid){

      alert("Merci d'entrer un addresse email correcte")
    }else{
      const formValue = this.fromForget.value;

      // Service reset password 

      this.authservice
      .resetPassword(formValue['email'])
      .pipe(
        map((response) => {

          //// //console.log(response);

          this.emailService.setEmail(formValue['email']);
          this.router.navigateByUrl('/auth/after-update');

        })
      )
      .subscribe()

      

      
    }
   
  }
}
